import { apiSlice } from './apiSlice';

export const graphSlice = apiSlice.injectEndpoints({
	tagTypes: ['glCode'],
	endpoints: (builder) => ({
		getAllGraphData: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyn-data-provider/get-lyndataprovider-company',
				method: 'POST',
				body: data,
			}),
		}),

		getDynamicTableData: builder.mutation({
			query: ({ url, data, params }) => ({
				url: `/lynorg-service/endpoint${url}`,
				method: 'POST',
				body: data,
				params,
			}),
		}),

		// getGraphDataByCode: builder.mutation({
		//   query: (data) => ({
		//     url: "/lynorg-service/endpoint/lyn-data-provider/get-lyndataprovider-company-code",
		//     method: "POST",
		//     body: data,
		//   }),
		// }),
		getQueryV3: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/query-v3',
				method: 'POST',
				body: data,
				// validateStatus: (response) => response.status === 200 || response?.ok === 1,
			}),
		}),
		getQueryV3Delta: builder.query({
			query: (payload) => ({
				url: '/lynorg-service/endpoint/process/query-v3',
				method: 'POST',
				body: payload,
				// validateStatus: (response) => response.status === 200 || response?.ok === 1,
			}),
			invalidatesTags: ['glCode'],
		}),
		getQueryV5: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/query-v5',
				method: 'POST',
				body: data,
				// validateStatus: (response) => response.status === 200 || response?.ok === 1,
			}),
		}),
		getAuthPermission: builder.mutation({
			query: (data) => ({
				url: '/authorization-service/endpoint/authorization/get-auth-for-user-by-type-only',
				method: 'POST',
				body: data,
			}),
		}),
		getAnnouncement: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/announcement/view',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		sendReaction: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/announcement/emoji-sent',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
	}),
});

export const {
	useGetAnnouncementMutation,
	useSendReactionMutation,
	useGetQueryV3DeltaQuery,
	useGetDynamicTableDataMutation,
	useGetAllGraphDataMutation,
	useGetQueryV3Mutation,
	useGetQueryV5Mutation,
	useGetAuthPermissionMutation,
} = graphSlice;
